import type { RoadKit } from "../kit/types";

/**
 * Gilded Causeway (MP-23, the Trophy Hall: 900 Trophies; contract tools/art/skins/README.md §Roads). A chequer of cream
 * and grey marble laid on the diagonal with gold joints and a gold stud where four stones meet (the ground shader's
 * paving, render/groundPave.ts: a band of gold glints sweeps across it), between white-marble kerbs with a gold rail,
 * dressed from `art/hq/skins/causeway/kit.glb` (tools/art/skins/roads_trophy.py; the folder is not `gilded`, which is
 * the Gilded tower kit's): a white-marble medallion with a gold laurel round a glowing star every third cell (the glow
 * rolls down the road), marble lantern posts with gold lanterns swinging from their arms, and spilled gold coins that
 * glint on their own beats under a twinkling star.
 */
const STAR_WAVE = { travel: 0.8, hz: 0.25 } as const;

export const CAUSEWAY: RoadKit = {
  id: "road.gilded",
  tint: [1.28, 1.2, 1.06],
  asset: "skins/causeway/kit",
  surface: {
    pattern: "diamond", scale: 2.2, jointWidth: 0.05, grain: 0.35, bevel: 0.5,
    stone: [0.6, 0.56, 0.48], stone2: [0.44, 0.42, 0.38], joint: [0.62, 0.42, 0.12],
    glow: { colour: [1.0, 0.66, 0.2], base: 0.05, pulse: 1.2, hz: 0.18, waveK: 1.6, sharp: 16, scatter: 0.15 },
  },
  // the kerbs first: the instance cap fills piece by piece, so a very long road thins its lanterns, never its edges
  pieces: [
    { piece: "kerb", every: 1, place: "centre", on: "straight", motion: { glow: 0.5, ...STAR_WAVE } },
    { piece: "kerbturn", every: 1, place: "centre", on: "turn", motion: { glow: 0.5, ...STAR_WAVE } },
    { piece: "medallion", every: 3, place: "centre", on: "straight", motion: { glow: 0.7, ...STAR_WAVE } },
    { piece: "post", every: 4, phase: 1, place: "verge", side: 0.6, on: "straight" },
    { piece: "lantern", every: 4, phase: 1, place: "verge", side: 0.48, on: "straight", lift: 0.69, motion: { sway: 9, hz: 0.42, glow: 0.25 } },
    { piece: "coins", every: 4, phase: 3, place: "verge", side: 0.56, on: "straight", motion: { glow: 0.9, hz: 0.8 } },
    { piece: "glint", every: 4, phase: 3, place: "verge", side: 0.56, on: "straight", detail: true, motion: { twinkle: 0.4 } },
  ],
};
